import ReloadImage from "@UI/ReloadImage";
import { sendMetric, getWhatId, pluralForm } from "@utils";
import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const startTimer = 6000;
// const dataUsers = Array(1)
//     .fill([
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/1.webp", text: "До 12 месяцев подписки Иви" },
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/2.webp", text: "45 дней подписки + 30% скидки на первое продление" },
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/3.webp", text: "1 месяц подписки KION на онлайн-кинотеатр" },
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/4.webp", text: "Скидка 300 рублей на первый заказ от 1000 рублей" },
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/5.webp", text: "Скидка на обучение профессии" },
//         // {img:require("./img/sber.png"), text:"СберПрайм - подписка 30 дней за 0₽"},
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/6.webp", text: "60 дней подписки на видеосервис Смотрёшка" },
//         { img: "https://storage-v.mypromos.ru/ris_promo/wheel/7.webp", text: "Роскошная подвеска в ПОДАРОК от SUNLIGHT!" },
//         // {img:require("./img/yandex.png"), text:"Скидка 400 рублей на первую покупку в Яндекс Маркете"},
//         // // {img:require("./img/yandex_plus.png"), text:""},
//         // {img:require("./img/mir_tankov.png"), text:"Подарки от «Мира танков»!"},
//     ])
//     .flat();
const dataRotate = { 6: 350, 7: 310, 8: 260, 9: 220 };

const AvaWheelModalWheel = inject("mainStore")(
    observer(({ mainStore }) => {
        const setting = mainStore.getMainStore("settingLego");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const abTestMetika =  mainStore.getMainStore("abTestMetika");


        const init = mainStore.getMainStore("init");
        const [timer, setTimer] = useState(setting.queueDuration * 1000);
        const [scrollInterval, setScrollInterval] = useState(setting.queueDuration * 1000);
        const [progress, setProgress] = useState(setting.queueDuration * 1000);
        const [currentIdx, setCurrentIdx] = useState(0);

        const isRotate = dataRotate[setting.queueDuration];

        const partnerName = init && init.data && init.data._p_n ? `${init.data._p_n}` : "Ris Promo";

        const preload_data = mainStore.getMainStore("preload_data");
        const { preloadWheel = [] } = preload_data;
        const arrOffer = preloadWheel && preloadWheel.length ? preloadWheel.slice(0, 8) : [];

        // let abTestMetika = mainStore.getMainStore("abTestMetika");
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        useEffect(() => {
            let interval = setInterval(() => setTimer((prev) => prev - 1000), 1000);
            if (!timer) {
                clearInterval(interval);
                sendMetric(`widget_step_1_show`, {
                    params1:  [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd ? wdCd : null,
                    params8: `${what_id}`,
                });
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_1_show",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }
                mainStore.setMainStore("isVisible", true);
                mainStore.setMainStore("modal", { type: "fortuneNew" });
            }

            return () => clearInterval(interval);
        }, [timer]);

        useEffect(() => {
            let interval = setInterval(() => setProgress((prev) => prev - 100), 100);
            if (!progress) clearInterval(interval);

            return () => clearInterval(interval);
        }, [progress]);

        useEffect(() => {
            // let step = Math.round(startTimer / dataUsers.length);
            let step = 1000;
            let interval = setInterval(() => setScrollInterval((prev) => prev - step), step);
            if (!timer) clearInterval(interval);
            setCurrentIdx((prev) => prev + 1);

            return () => clearInterval(interval);
        }, [scrollInterval]);

        return (
            <div className="ava-wheel-block">
                <div className="ava-wheel__container wheel-animation">
                    <div className="wheel-center">
                        <div className="wheel-center-inner"></div>
                    </div>

                    <div className="text__title" dangerouslySetInnerHTML={{ __html: arrOffer[currentIdx] ? arrOffer[currentIdx]?.title : "" }}></div>
                    {/* <div className="wheel-animation__vendors">
                        <span className="wheel-animation__title">{offerFilter[currentIdx] ? offerFilter[currentIdx].title : ""}</span>
                    </div> */}

                    {arrOffer.map((i, idx) => {
                        let index = idx;
                        let step = 360 / 8;
                        let scrollSeconds = scrollInterval / 1000;
                        let rotate = index * step + step * scrollSeconds + isRotate;

                        // console.log(rotate);

                        return (
                            <div key={idx} className="wheel-animation__ava" style={{ transform: `rotate(-${rotate}deg)` }}>
                                <ReloadImage
                                    src={i?.squareLogo}
                                    style={{
                                        transform: `rotate(${rotate}deg) ${currentIdx == idx ? " scale(1.4)" : currentIdx > idx ? "scale(0.9)" : ""}`,
                                        opacity: currentIdx > idx ? 0 : 1,
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>

                <div className="text__block">
                    <span className="title" dangerouslySetInnerHTML={{ __html: setting.isPartnerHeaderVariant ? `Подбираем подарки <br/> от партнёров ${partnerName} 🔎` : "Здравствуйте! 👋" }}></span>
                    <span className="desc">Вы можете выбрать любой подарок</span>
                </div>

                <div className="animation__bottom">
                    <div className="animation__btn">
                        <span className="animation__btn-text">
                            Ваша очередь наступит через {timer / 1000} секунд{pluralForm(timer / 1000, ["у", "ы", ""])}
                        </span>
                        <div className="animation__progress_new" style={{ "--countAnimation": `${setting.queueDuration}s` }}></div>
                    </div>
                </div>
            </div>
        );
    }),
);

export default AvaWheelModalWheel;
